import React from "react";
import "./ListGroup.scss";
import { ListGroupItems, NoResultText } from "@components";
import { Typography } from "@genie-ui/react";

const ListGroup = ({ orgData, getOptionItem, title, noMatchesLabel }) => {
  return (
    <li className="menu__list-group">
      {title && (
        <>
          <Typography variant="h7" className="menu__list__title">
            {title}
          </Typography>
          {(!orgData || orgData?.length <= 0) && (
            <NoResultText>{noMatchesLabel}</NoResultText>
          )}
        </>
      )}
      {orgData?.length > 0 && (
        <ListGroupItems orgData={orgData} getOptionItem={getOptionItem} />
      )}
    </li>
  );
};

export default ListGroup;
